module.exports = __webpack_public_path__ + "img/image.7cf1586c.svg";